/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GetBillingPriceOutputJsonApiModel = {
  id: "",
  "billing-price": {
    jsonApi: "hasOne",
    type: "billing-prices",
  },
  "has-billing-events": "",
};
